import { injectIntl } from 'react-intl';
import { Dialog, ScreenMessagePanelContainer, Label, ButtonStandard, ButtonLight, formatMessage } from 'cw-ui-core';
import css from './DownloadUsersDialog.scss';
import layoutCss from 'src/styles/layout.scss';
import Locale from 'src/i18n';
import React from 'react';

export const DOWNLOAD_USERS_DIALOG = 'DOWNLOAD_USERS_DIALOG';

const DownloadUsersDialog = ({
    onDownloadCancel,
    onExport,
    onExportAll,
    usersCount = 0,
    isUsersCheckboxSelected,
    isFilterApplied,
}) => {
    const dialogButtons = [
        <ButtonLight
            key="cancel_export"
            automationName="cancel_export"
            className={css.cancelButton}
            value={formatMessage(Locale.cancel)}
            onClick={onDownloadCancel}
        />,
        <ButtonStandard
            key="export_users"
            automationName="export_users"
            className={css.exportButton}
            value={isUsersCheckboxSelected ? formatMessage(Locale.export) : formatMessage(Locale.exportAll)}
            onClick={isUsersCheckboxSelected ? onExport : onExportAll}
        />,
    ];

    const getDialogMessage = () => {
        if (!isUsersCheckboxSelected && !isFilterApplied) {
            return formatMessage(Locale.allUsersWithoutFilter);
        }
        if (isUsersCheckboxSelected && !isFilterApplied) {
            return formatMessage(Locale.selectedUsersWithoutFilter);
        }
        if (!isUsersCheckboxSelected && isFilterApplied) {
            return formatMessage(Locale.allUsersWithFilter);
        }
        return formatMessage(Locale.selectedUsersWithFilter);
    };

    return (
        <Dialog dialogId={DOWNLOAD_USERS_DIALOG} header={formatMessage(Locale.exportUserList)} buttons={dialogButtons}>
            <div className={css.wrap}>
                <div className={layoutCss.podCol}>
                    <ScreenMessagePanelContainer className={css.screenMessage} screenKey={DOWNLOAD_USERS_DIALOG} />
                    <Label value={getDialogMessage()} />
                    {isUsersCheckboxSelected && (
                        <div className={css.userCountText}>{formatMessage(Locale.usersSelected, { usersCount })}</div>
                    )}
                </div>
            </div>
        </Dialog>
    );
};

export default injectIntl(DownloadUsersDialog);
